import { gql } from 'urql'

const TZ = 'America/Santiago'

function chileParts(date) {
  const parts = {}
  new Intl.DateTimeFormat('en-US', {
    timeZone: TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).formatToParts(date).forEach((part) => {
    if (part.type !== 'literal') parts[part.type] = part.value
  })
  return parts
}

export const nowBannerDateTimeLocal = () => formatBannerDateTimeLocal(new Date())

export const formatBannerDateTimeLocal = (date) => {
  const p = chileParts(date)
  return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}`
}

export const toBannerDateTimeLocal = (value) => {
  if (!value) return ''
  return formatBannerDateTimeLocal(new Date(value))
}

export const fromBannerDateTimeLocal = (value) => {
  if (!value) return undefined
  const target = value.slice(0, 16)
  let lo = Date.UTC(2020, 0, 1)
  let hi = Date.UTC(2040, 0, 1)
  while (hi - lo > 60_000) {
    const mid = Math.floor((lo + hi) / 2)
    if (formatBannerDateTimeLocal(new Date(mid)) <= target) lo = mid
    else hi = mid
  }
  return new Date(lo).toISOString()
}

export const formatBannerScheduledAt = (value) => {
  if (!value) return '—'
  const p = chileParts(new Date(value))
  return `${p.day}-${p.month}-${p.year} ${p.hour}:${p.minute} hrs`
}

export const BANNER_CHANNELS = [
  { value: 'BANNER', label: 'Banner' },
  { value: 'MODAL', label: 'Modal' },
]

const BANNER_CHANNEL_LABELS = {
  BANNER: 'Banner',
  MODAL: 'Modal',
  BELL: 'Campana de notificaciones',
}

export const formatBannerChannel = (channel) =>
  BANNER_CHANNEL_LABELS[channel] || channel

const BANNER_FIELDS = `
  id
  title
  message
  template
  channel
  isActive
  scheduledAt
  endsAt
  linkUrl
  linkLabel
  dismissalCount
  linkClickCount
  bellPublishedAt
  createdAt
  updatedAt
`

const BANNER_DISMISSAL_FIELDS = `
  id
  userId
  userEmail
  companyId
  companyName
  bannerId
  dismissedChannels
  lastDismissedChannel
  dismissedAt
  createdAt
  updatedAt
`

export const GET_BANNERS = gql`
  query GetBanners {
    banners {
      ${BANNER_FIELDS}
    }
  }
`

const BANNER_LINK_CLICK_FIELDS = `
  id
  userId
  userEmail
  companyId
  companyName
  bannerId
  linkUrl
  linkLabel
  channel
  clickedAt
  createdAt
`

export const GET_BANNER_DISMISSALS = gql`
  query GetBannerDismissals($bannerId: String!) {
    bannerDismissals(bannerId: $bannerId) {
      ${BANNER_DISMISSAL_FIELDS}
    }
  }
`

export const GET_BANNER_LINK_CLICKS = gql`
  query GetBannerLinkClicks($bannerId: String!) {
    bannerLinkClicks(bannerId: $bannerId) {
      ${BANNER_LINK_CLICK_FIELDS}
    }
  }
`

export const formatBannerDismissedAt = (value) => {
  if (!value) return '—'
  const p = chileParts(new Date(value))
  return `${p.day}-${p.month}-${p.year} ${p.hour}:${p.minute} hrs`
}

export const formatBannerEndsAt = formatBannerScheduledAt

export const CREATE_BANNER = gql`
  mutation CreateBanner($input: CreateBannerInput!) {
    createBanner(input: $input) {
      ${BANNER_FIELDS}
    }
  }
`

export const UPDATE_BANNER = gql`
  mutation UpdateBanner($input: UpdateBannerInput!) {
    updateBanner(input: $input) {
      ${BANNER_FIELDS}
    }
  }
`

export const DELETE_BANNER = gql`
  mutation DeleteBanner($id: String!) {
    deleteBanner(id: $id)
  }
`

export const SET_BANNER_ACTIVE = gql`
  mutation SetBannerActive($id: String!, $isActive: Boolean!) {
    setBannerActive(id: $id, isActive: $isActive) {
      ${BANNER_FIELDS}
    }
  }
`
